const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const {checkEmailPassword} = require("../../shared/PasswordCheck");
const AT = require("../core/vault/ActionTypes");
const Input = require("./checkout/Input");
const Checkbox = require("../core/view/Checkbox");
const CopyTable = require("./data/CopyTable");
const CoreCopy = require("../core/util/CopyTable");

const styles = require("./styles/PageAccountSetup.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "PasswordSetup",

		propTypes: {
			code: PT.string,
			email: PT.string,
			type: PT.string,
			showCoppa: PT.bool,
			showPassword: PT.bool,
			isMultiple: PT.number,
			topCopy: PT.any,
			bottomCopy: PT.any,
			backendError: PT.any,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			setupAccountInvalidPassword: function(error) {
				this.setState({
					passwordErrorType: error,
					passwordErrorFields: ["newPassword"],
				});
			},
		},

		getInitialState: function() {
			return {
				acceptedTerms: false,
				acceptedCoppa: false,
				termsHaveErrored: false,
				coppaHasErrored: false,

				passwordErrorFields: [],
				passwordErrorType: "",
				password: "",
				passwordRepeat: "",
			};
		},

		validateOrSubmit: function() {
			const {showPassword, showCoppa, code, type, email} = this.props;
			const {
				password,
				passwordRepeat,
				acceptedTerms,
				acceptedCoppa,
			} = this.state;
			let passwordErrorType = null;
			let passwordErrorFields = [];
			let termsHaveErrored = false;
			let coppaHasErrored = false;
			let passwordValid = false;
			if (showPassword) {
				if (!password) {
					passwordErrorType = "E_MISSING";
					passwordErrorFields = ["newPassword"];
				} else if (password !== passwordRepeat) {
					passwordErrorType = "E_PASSWORD_REPEAT_MISMATCH";
					passwordErrorFields = ["newPasswordRepeat"];
				} else {
					const checkPasswordResult = checkEmailPassword(
						password,
						passwordRepeat
					);
					if (!checkPasswordResult.valid) {
						passwordValid = false;
						passwordErrorType = checkPasswordResult.error;
						passwordErrorFields = ["newPassword"];
					} else {
						passwordValid = true;
					}
				}
			}
			if (showCoppa) {
				termsHaveErrored = !acceptedTerms;
				coppaHasErrored = !acceptedCoppa;
			}
			if (
				((showPassword && passwordValid) || !showPassword) &&
				!termsHaveErrored &&
				!coppaHasErrored
			) {
				this.props.dispatch({
					type: AT.ACCOUNT_PASSWORD_SETUP_REQUEST,
					email,
					password,
					code,
					codeType: type,
					passwordRequired: showPassword,
				});
			}

			this.setState({
				termsHaveErrored,
				coppaHasErrored,
				passwordErrorType,
				passwordErrorFields,
			});
		},

		// Check whether passwords are valid and boxes are checked.
		onContinue: function() {
			this.doSubmit =
				this.doSubmit ||
				_.throttle(this.validateOrSubmit, 500, {
					leading: true,
					trailing: false,
				});
			this.doSubmit();
		},

		toggleAcceptTerms: function() {
			this.setState({acceptedTerms: !this.state.acceptedTerms});
		},

		toggleAcceptCoppa: function() {
			this.setState({acceptedCoppa: !this.state.acceptedCoppa});
		},

		renderErrorEl: function(errorText, shouldShow) {
			const errorClass = shouldShow ? styles.errorText : styles.errorTextHidden;
			return <div className={errorClass}>{"* " + errorText}</div>;
		},

		render: function() {
			const {
				passwordErrorFields,
				passwordErrorType,
				acceptedTerms,
				acceptedCoppa,
				termsHaveErrored,
				coppaHasErrored,
			} = this.state;

			const {
				showCoppa,
				showPassword,
				type,
				email,
				topCopy,
				bottomCopy,
				backendError,
			} = this.props;

			const continueButton = (
				<div className={styles.button} onClick={this.onContinue}>
					{type === "staff" && !showPassword ? "Accept Invite" : "Continue"}
				</div>
			);
			const acceptErrorText = CopyTable.getFormErrorCopy()["E_MISSING"];
			const termsError = this.renderErrorEl(acceptErrorText, termsHaveErrored);
			const coppaError = this.renderErrorEl(acceptErrorText, coppaHasErrored);

			const acceptEl = showCoppa ? (
				<div className={styles.accept}>
					<Checkbox
						className={styles.accept}
						text={CopyTable.getAcceptTermsCopy(styles)}
						onClick={this.toggleAcceptTerms}
						isSelected={acceptedTerms}
						isErrored={termsHaveErrored}
						noTextHover={true}
						tabIndex={6}
					/>
					{termsError}
					<Checkbox
						className={styles.accept}
						text={CopyTable.getAcceptCoppaCopy()}
						onClick={this.toggleAcceptCoppa}
						isSelected={acceptedCoppa}
						isErrored={coppaHasErrored}
						noTextHover={true}
						tabIndex={7}
					/>
					{coppaError}
				</div>
			) : null;
			const passwordEl = showPassword ? (
				<Input
					className={styles.input}
					inputType={"password"}
					placeholder={"Enter password"}
					onUpdate={val => this.setState({password: val})}
					nameAttr={"password"}
					staticLabel={CoreCopy.passwordRuleCopy}
					showErrorType={
						_.includes(passwordErrorFields, "newPassword")
							? passwordErrorType
							: null
					}
					checkType={"password"}
					tabIndex={4}
				/>
			) : null;
			const repeatPasswordEl = showPassword ? (
				<Input
					className={styles.input}
					inputType={"password"}
					placeholder={"Re-enter password"}
					onUpdate={val => this.setState({passwordRepeat: val})}
					nameAttr={"passwordRepeat"}
					showErrorType={
						_.includes(passwordErrorFields, "newPasswordRepeat")
							? passwordErrorType
							: null
					}
					checkType={"passwordRepeat"}
					tabIndex={5}
				/>
			) : null;

			return (
				<div className={styles.across}>
					<div className={styles.formContainer}>
						<div className={styles.form}>
							<div className={styles.why}>{topCopy}</div>
							<div className={styles.emailContainer}>
								<span className={styles.emailTitle}>Account Email:</span>
								<span className={styles.email}>{email}</span>
							</div>
							{passwordEl}
							{repeatPasswordEl}
							{acceptEl}
							<div className={styles.why}>{bottomCopy}</div>
							{backendError}
							{continueButton}
						</div>
					</div>
				</div>
			);
		},
	})
);
